import { colors } from "../styles";
import { SectionFlexRow } from "./General";
import { ReactComponent as BackIcon } from "../assets/arrowleft.svg";
import { ReactComponent as AngleDividerIcon } from "../assets/icons/angled-divider.svg";
import T from "./Typography";

const HeaderBreadcrumbs = ({
  breadcrumbs,
  handleBack,
}: {
  breadcrumbs: Array<string>;
  handleBack: () => void;
}) => {
  return (
    <SectionFlexRow>
      <div
        style={{
          width: 40,
          height: 32,
          borderRight: `2px solid ${colors.gray_400}`,
        }}
        className="flex items-center"
      >
        <div style={{ cursor: "pointer" }} onClick={handleBack}>
          <BackIcon />
        </div>
      </div>
      <SectionFlexRow
        sx={{
          marginLeft: "24px",
          gap: "16px",
          width: "auto",
        }}
      >
        {breadcrumbs.map((breadcrumb, index) => {
          const isLastItem = index === breadcrumbs.length - 1;
          return (
            <>
              <T
                key={breadcrumb}
                sx={{
                  flexShrink: 0,
                  ...(isLastItem && {
                    backgroundColor: "#DCE3F6",
                    padding: "8px",
                    borderRadius: "4px",
                  }),
                }}
                variant="smMed"
                color={colors.gray_500}
              >{`${breadcrumb}`}</T>
              {!isLastItem && (
                <AngleDividerIcon key={`${breadcrumb}-${index}`} />
              )}
            </>
          );
        })}
      </SectionFlexRow>
    </SectionFlexRow>
  );
};

export default HeaderBreadcrumbs;
